import { connect } from "react-redux";
import {
  initMenaBanner,
  shopMena,
  stayHere
} from "@template/state/modules/menaBanner/actions";
import { isMenaBannerVisible } from "@template/state/modules/menaBanner";
import MenaBannerContainer from "./MenaBannerContainer";

const mapStateToProps = state => ({
  visible: isMenaBannerVisible(state)
});

const mapDispatchToProps = {
  initMenaBanner,
  shopMena,
  stayHere
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenaBannerContainer);
